import React from "react";
import "./LandingPage3.css";

const LandingPage3 = ({ videoLinks, features }) => {
  return (
    <main className="features-main">
      <h1 className="features-heading">
        Unique <span className="highlighted">Features</span> of Shutter
      </h1>

      {features.map(({ title, description, points, img, vid, alt, reverse }, index) => (
        <section
          key={index}
          className={`feature-section ${reverse ? "reverse" : ""}`}
        >
          <div className="feature-text">
            <h2>{title}</h2>
            <p>
              {description}
            </p>
            <ul>
              {points.map((point, index) => (
                <li key={index}>
                  <i className="fas fa-check-circle"></i>
                  {point}
                </li>
              ))}           
            </ul>
            <button type="button" onClick={() => window.location.href = '/webapp'}>
              Try It Yourself
              <i className="fas fa-arrow-right"></i>
            </button>
          </div>
          <div className="feature-image">
            {/* <img src={img} alt={alt} /> */}
            {vid && <video src={vid} autoPlay loop muted playsInline />}
          </div>
        </section>
      ))}
    </main>
  );
};

export default LandingPage3;
